import { IEmail } from "../shared/IEmail.ts";
import { IWorldMap } from "../shared/IGameData.ts";
import { IPlayer, ISharedPlayer } from "../shared/IPlayer.ts";
import { IResources } from "../shared/IResources.ts";
import { IBuildingsDefinition, IDropItemDefinition, ITroopDefinition } from "../shared/JsonDefinitions.ts";
import { MechanicsCalculator } from "../shared/MechanicsCalculator.ts";
import { PlayerBattleStance } from "../shared/PlayerBattleStance.ts";

export class PlayerStatistics {
  public productionPerMinute: IResources = {
    wood: 0,
    stone: 0,
    copper: 0,
    food: 0,
    population: 0,
    mana: 0
  };
  public housingCapacity: number = 0;
  public maxStorageCapacity: number = 0;
  public consumptionPerMinute: IResources = {
    wood: 0,
    stone: 0,
    copper: 0,
    food: 0,
    population: 0,
    mana: 0
  };
  public population: number = 0;
  public units: number = 0;
}

export interface ILocalPlayer extends IPlayer {
  statistics: PlayerStatistics;
}

/**
 * Game state DTO. This is basically IGameData but with a few extra fields.
*/
export class GameState {
  public players: Map<number, ISharedPlayer> = new Map();
  public localPlayer: ILocalPlayer | null = null;

  /**
   * World map data.
   */
  public worldMap!: IWorldMap;

  /**
   * Buildings and slots configuration.
   */
  public configuration!: IBuildingsDefinition;

  /**
   * Troop definitions
   */
  public troopDefinitions!: ITroopDefinition[];

  /**
   * Items definitions
   */
  public itemDefinitions!: IDropItemDefinition[];

  public emails: IEmail[] = [];

  /**
   * MechanicsCalculator instance, this is a local object not sent from the server.
   */
  public mechanicsCalculator!: MechanicsCalculator;

  /**
   * UX related state (mostly account related).
   */
  public uxState: UxState = new UxState();

  //public selectedHeroId: number | undefined;
}

export interface IReportLink {
  id: string;
  title: string;
  winner: PlayerBattleStance;
}


export class UxState {
  isAuthenticated: boolean = false;
  accountName: string = "";
  subject: string = "";
  token: string = "";
  playerId: string = "";
}